(function () {
  if (window.GeomatShippingCalculatorAssetLoaded) {
    if (typeof window.initGeomatShippingCalculators === "function") {
      window.initGeomatShippingCalculators(document);
    }

    return;
  }

  window.GeomatShippingCalculatorAssetLoaded = true;

  const BRAZIL = "Brazil";
  const STATE_NAMES = {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapa",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceara",
    DF: "Distrito Federal",
    ES: "Espirito Santo",
    GO: "Goias",
    MA: "Maranhao",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Para",
    PB: "Paraiba",
    PR: "Parana",
    PE: "Pernambuco",
    PI: "Piaui",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondonia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "Sao Paulo",
    SE: "Sergipe",
    TO: "Tocantins"
  };

  function initShippingCalculators(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(".js-shipping-calculator").forEach(function (calculator) {
      if (calculator.dataset.initialized === "true") {
        return;
      }

      calculator.dataset.initialized = "true";

      const cepInput = calculator.querySelector(".js-shipping-calculator-cep");
      const button = calculator.querySelector(".js-shipping-calculator-button");
      const feedback = calculator.querySelector(".js-shipping-calculator-feedback");
      const results = calculator.querySelector(".js-shipping-calculator-results");
      const shippingContext = calculator.dataset.shippingContext || "cart";
      const productFormId = calculator.dataset.productFormId || "";

      if (!cepInput || !button || !feedback || !results) {
        return;
      }

      button.addEventListener("click", calculateShipping);
      cepInput.addEventListener("input", maskCep);
      cepInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          calculateShipping();
        }
      });

      async function calculateShipping() {
        const cep = onlyDigits(cepInput.value);

        clearOutput();

        if (cep.length !== 8) {
          setFeedback("Digite um CEP valido com 8 numeros.", "error");
          return;
        }

        setLoading(true);

        try {
          const province = await getProvinceFromCep(cep);
          const rates =
            shippingContext === "product"
              ? await getProductShippingRates(cep, province)
              : await getShippingRates(cep, province);

          if (!rates.length) {
            setFeedback("Nenhuma opcao de frete disponivel para este CEP.", "info");
            return;
          }

          renderRates(rates);
        } catch (error) {
          console.error("Erro ao calcular frete.", error);
          setFeedback("Nao foi possivel calcular o frete agora. Tente novamente.", "error");
        } finally {
          setLoading(false);
        }
      }

      async function getProvinceFromCep(cep) {
        const response = await fetch("https://viacep.com.br/ws/" + cep + "/json/");

        if (!response.ok) {
          throw new Error("Falha ao consultar o CEP.");
        }

        const address = await response.json();

        if (address.erro || !address.uf) {
          throw new Error("CEP invalido.");
        }

        return STATE_NAMES[address.uf] || "";
      }

      async function getShippingRates(cep, province) {
        const params = new URLSearchParams();

        params.set("shipping_address[zip]", cep);
        params.set("shipping_address[country]", BRAZIL);

        if (province) {
          params.set("shipping_address[province]", province);
        }

        const response = await fetch("/cart/shipping_rates.json?" + params.toString(), {
          headers: {
            Accept: "application/json"
          }
        });

        const payload = await response.json().catch(function () {
          return {};
        });

        if (!response.ok) {
          throw new Error(payload.message || "Falha ao consultar as opcoes de frete.");
        }

        return Array.isArray(payload.shipping_rates) ? payload.shipping_rates : [];
      }

      async function getProductShippingRates(cep, province) {
        const lineItem = getSelectedProductLineItem();

        if (!lineItem) {
          throw new Error("Produto ou variante nao encontrada para calcular o frete.");
        }

        return withTemporaryCart([lineItem], function () {
          return getShippingRates(cep, province);
        });
      }

      function getSelectedProductLineItem() {
        if (!productFormId) {
          return null;
        }

        const productForm = document.getElementById(productFormId);

        if (!productForm) {
          return null;
        }

        const variantInput = productForm.querySelector('input[name="id"]');
        const quantityInput = productForm.querySelector('input[name="quantity"]');
        const variantId = onlyDigits(variantInput ? variantInput.value : "");
        const quantity = Math.max(parseInt(quantityInput?.value || "1", 10) || 1, 1);

        if (!variantId) {
          return null;
        }

        return {
          id: Number(variantId),
          quantity: quantity
        };
      }

      async function withTemporaryCart(items, callback) {
        const snapshot = await getCartSnapshot();

        try {
          await replaceCartItems(items);
          return await callback();
        } finally {
          await restoreCartSnapshot(snapshot);
        }
      }

      async function getCartSnapshot() {
        const response = await fetch("/cart.js", {
          headers: {
            Accept: "application/json"
          }
        });

        if (!response.ok) {
          throw new Error("Falha ao carregar o carrinho atual.");
        }

        return response.json();
      }

      async function replaceCartItems(items) {
        await postCartJson("/cart/clear.js", {});
        await addCartItems(items);
      }

      async function restoreCartSnapshot(snapshot) {
        await postCartJson("/cart/clear.js", {});

        const items = Array.isArray(snapshot?.items) ? snapshot.items.map(mapCartItem).filter(Boolean) : [];

        if (items.length) {
          await addCartItems(items);
        }

        const updatePayload = {};

        if (snapshot?.note != null) {
          updatePayload.note = snapshot.note;
        }

        if (snapshot?.attributes && typeof snapshot.attributes === "object") {
          updatePayload.attributes = snapshot.attributes;
        }

        if (Object.keys(updatePayload).length) {
          await postCartJson("/cart/update.js", updatePayload);
        }
      }

      async function addCartItems(items) {
        if (!Array.isArray(items) || !items.length) {
          return;
        }

        await postCartJson("/cart/add.js", {
          items: items
        });
      }

      async function postCartJson(url, payload) {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify(payload || {})
        });

        const data = await response.json().catch(function () {
          return {};
        });

        if (!response.ok) {
          throw new Error(data.description || data.message || "Falha ao atualizar o carrinho.");
        }

        return data;
      }

      function mapCartItem(item) {
        const variantId = Number(item?.variant_id || item?.id);
        const quantity = Math.max(parseInt(item?.quantity, 10) || 0, 0);

        if (!variantId || !quantity) {
          return null;
        }

        const mappedItem = {
          id: variantId,
          quantity: quantity
        };

        const properties = sanitizeProperties(item.properties);
        const sellingPlanId = item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan;

        if (Object.keys(properties).length) {
          mappedItem.properties = properties;
        }

        if (sellingPlanId) {
          mappedItem.selling_plan = sellingPlanId;
        }

        return mappedItem;
      }

      function sanitizeProperties(properties) {
        if (!properties || typeof properties !== "object") {
          return {};
        }

        return Object.keys(properties).reduce(function (result, key) {
          if (properties[key] != null) {
            result[key] = properties[key];
          }

          return result;
        }, {});
      }

      function renderRates(rates) {
        results.innerHTML = "";

        const list = document.createElement("div");
        list.className = "shipping-calculator__results overflow-hidden rounded";

        rates.forEach(function (rate) {
          const item = document.createElement("div");
          item.className = "shipping-calculator__rate px-4 py-3";

          const serviceName = escapeHtml(rate.presentment_name || rate.name || "Entrega");
          const deadline = escapeHtml(getDeadlineLabel(rate));
          const price = formatPrice(rate.price);

          item.innerHTML = `
            <div class="wrapper-shipping-results">
              <p class="shipping-name">${serviceName}</p>
              <div>
                <p class="shipping-date">${deadline}</p>
                <p class="shipping-price">${price}</p>
              </div>
            </div>
          `;

          list.appendChild(item);
        });

        results.appendChild(list);
      }

      function getDeadlineLabel(rate) {
        const minDays = getNumber(
          rate.min_delivery_time || rate.minDeliveryTime || rate.min_delivery_days || rate.delivery_range?.min
        );
        const maxDays = getNumber(
          rate.max_delivery_time || rate.maxDeliveryTime || rate.max_delivery_days || rate.delivery_range?.max
        );
        const singleDays = getNumber(
          Array.isArray(rate.delivery_days)
            ? rate.delivery_days[0]
            : rate.delivery_days || rate.delivery_time || rate.estimated_days
        );

        if (minDays && maxDays) {
          return "" + minDays + " a " + maxDays + " dias uteis";
        }

        if (singleDays) {
          return "" + singleDays + (singleDays === 1 ? " dia util" : " dias uteis");
        }

        if (rate.description) {
          return "" + rate.description;
        }

        return "Prazo sob consulta";
      }

      function formatPrice(price) {
        const numericPrice = Number(String(price).replace(",", "."));

        if (!Number.isFinite(numericPrice)) {
          return "Valor indisponivel";
        }

        if (numericPrice === 0) {
          return "Gratis";
        }

        const formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL"
        });
        const parts = formatter.formatToParts(numericPrice);
        const currency = parts.find(function (part) {
          return part.type === "currency";
        })?.value || "R$";
        const amount = parts
          .filter(function (part) {
            return part.type !== "currency" && part.type !== "literal";
          })
          .map(function (part) {
            return part.value;
          })
          .join("");

        return currency + " " + amount;
      }

      function setLoading(isLoading) {
        button.disabled = isLoading;
        button.textContent = isLoading ? "Calculando" : "Consultar";
      }

      function setFeedback(message, type) {
        const colors = {
          success: "#166534",
          error: "#b91c1c",
          info: "#4b5563"
        };

        feedback.textContent = message;
        feedback.style.color = colors[type] || colors.info;
      }

      function clearOutput() {
        feedback.textContent = "";
        results.innerHTML = "";
      }

      function maskCep(event) {
        let value = onlyDigits(event.target.value).slice(0, 8);

        if (value.length > 5) {
          value = value.replace(/^(\d{5})(\d{0,3})$/, "$1-$2");
        }

        event.target.value = value;
      }
    });
  }

  function getNumber(value) {
    if (value == null) {
      return null;
    }

    const match = String(value).match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  function onlyDigits(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  window.initGeomatShippingCalculators = initShippingCalculators;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initShippingCalculators(document);
    });
  } else {
    initShippingCalculators(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initShippingCalculators(event.target || document);
  });
})();
